var payrightdata = {
    "rates": [
        {
            "minimumSaleAmount": 166.67,
            "minimumDepositPercentage": 10,
            "term": 3,
            "minimumPurchase": 150,
            "maximumPurchase": 500,
            "rate00": null,
            "rate05": null,
            "rate10": 0.99,
            "rate15": null,
            "rate20": null,
            "rate25": null,
            "rate30": null,
            "rate35": null,
            "rate40": null,
            "rate45": null,
            "rate50": null
        },
        {
            "minimumSaleAmount": 556.67,
            "minimumDepositPercentage": 10,
            "term": 6,
            "minimumPurchase": 501,
            "maximumPurchase": 1000,
            "rate00": null,
            "rate05": null,
            "rate10": 1.49,
            "rate15": null,
            "rate20": null,
            "rate25": null,
            "rate30": null,
            "rate35": null,
            "rate40": null,
            "rate45": null,
            "rate50": null
        },
        {
            "minimumSaleAmount": 1112.22,
            "minimumDepositPercentage": 10,
            "term": 6,
            "minimumPurchase": 1001,
            "maximumPurchase": 1500,
            "rate00": null,
            "rate05": null,
            "rate10": 2.99,
            "rate15": null,
            "rate20": null,
            "rate25": null,
            "rate30": null,
            "rate35": null,
            "rate40": null,
            "rate45": null,
            "rate50": null
        },
        {
            "minimumSaleAmount": 1667.78,
            "minimumDepositPercentage": 10,
            "term": 12,
            "minimumPurchase": 1501,
            "maximumPurchase": 3000,
            "rate00": null,
            "rate05": null,
            "rate10": 4.99,
            "rate15": null,
            "rate20": null,
            "rate25": null,
            "rate30": null,
            "rate35": null,
            "rate40": null,
            "rate45": null,
            "rate50": null
        },
        {
            "minimumSaleAmount": 3334.44,
            "minimumDepositPercentage": 10,
            "term": 24,
            "minimumPurchase": 3001,
            "maximumPurchase": 4000,
            "rate00": null,
            "rate05": null,
            "rate10": 7.99,
            "rate15": null,
            "rate20": null,
            "rate25": null,
            "rate30": null,
            "rate35": null,
            "rate40": null,
            "rate45": null,
            "rate50": null
        },
        {
            "minimumSaleAmount": 4445.56,
            "minimumDepositPercentage": 10,
            "term": 36,
            "minimumPurchase": 4001,
            "maximumPurchase": 6000,
            "rate00": null,
            "rate05": null,
            "rate10": 9.99,
            "rate15": null,
            "rate20": null,
            "rate25": null,
            "rate30": null,
            "rate35": null,
            "rate40": null,
            "rate45": null,
            "rate50": null
        },
        {
            "minimumSaleAmount": 6667.78,
            "minimumDepositPercentage": 10,
            "term": 36,
            "minimumPurchase": 6001,
            "maximumPurchase": 8000,
            "rate00": null,
            "rate05": null,
            "rate10": 11.99,
            "rate15": null,
            "rate20": null,
            "rate25": null,
            "rate30": null,
            "rate35": null,
            "rate40": null,
            "rate45": null,
            "rate50": null
        }
    ],
    "establishmentFees": [
        {
            "initialEstFee": 5,
            "repeatEstFee": 5,
            "term": 3
        },
        {
            "initialEstFee": 0,
            "repeatEstFee": 0,
            "term": 2
        },
        {
            "initialEstFee": 89.95,
            "repeatEstFee": 19.95,
            "term": 60
        },
        {
            "initialEstFee": 89.95,
            "repeatEstFee": 19.95,
            "term": 48
        },
        {
            "initialEstFee": 59.9,
            "repeatEstFee": 19.95,
            "term": 36
        },
        {
            "initialEstFee": 59.9,
            "repeatEstFee": 19.95,
            "term": 30
        },
        {
            "initialEstFee": 59.9,
            "repeatEstFee": 19.95,
            "term": 24
        },
        {
            "initialEstFee": 59.9,
            "repeatEstFee": 19.95,
            "term": 18
        },
        {
            "initialEstFee": 59,
            "repeatEstFee": 19.95,
            "term": 12
        },
        {
            "initialEstFee": 49,
            "repeatEstFee": 19.95,
            "term": 9
        },
        {
            "initialEstFee": 39,
            "repeatEstFee": 19.95,
            "term": 6
        }
    ],
    "otherFees": {
        "monthlyAccountKeepingFee": 3.5,
        "paymentProcessingFee": 2.95
    }
};
function getRepayments(saleAmount) {
      try {
          var updatedSaleAmount = saleAmount;

          var {
              rates,
              establishmentFees,
              otherFees: { monthlyAccountKeepingFee, paymentProcessingFee },
          } = payrightdata;

          let depositPercentage = 0;
          let depositAmount = 0;
          let loanAmount = 0;

          var rateCards = rates.filter((rate) => {
              depositPercentage = rate.minimumDepositPercentage;
              depositAmount = updatedSaleAmount * (depositPercentage / 100);
              loanAmount = parseFloat((updatedSaleAmount - depositAmount).toFixed(2));

              if (loanAmount >= rate.minimumPurchase && loanAmount <= rate.maximumPurchase) {
                  return rate;
              }
          });
          var rateCard = rateCards[0];
          var paymentPeriod = rateCard.term;
          var numberOfRepayments = Math.round(paymentPeriod * (26 / 12));

          var establishmentFee = establishmentFees.find(
              (rate) => rate.term === paymentPeriod
          ).initialEstFee;

          var accountKeepingFee = (monthlyAccountKeepingFee * 12) / 26;

          var totalAmount =
              (loanAmount + establishmentFee) / numberOfRepayments +
              (accountKeepingFee + paymentProcessingFee);
          var payments = totalAmount.toFixed(2);
          //var repayments = '${numberOfRepayments} fortnightly payments of $${payments}';
          var repayments = '';

          return {
              updatedSaleAmount,
              depositPercentage,
              loanAmount,
              totalAmount,
              establishmentFee,
              accountKeepingFee,
              paymentProcessingFee,
              numberOfRepayments,
              payments,
              repayments,
          };
      } catch (e) {
          console.error(e);
          throw new Error('Error fetching repayments');
      }
  }
var wishlistFilterTemplate = {
    // Grid Template
  	'soldOutClass': 'sold-out-wishlist',
    'productGridItemHtml':  '<div class="product-block product-{{productIdClass}} {{soldOutClass}} flex column {{maxColsClass}} min-cols-2 {{itemGridWidthClass}}">' +
  								'<div class="wishlist_products">'+
  								'{{WishlistClose}}' +
                                '<div class="image">' +
                                    '<div class="inner">' +
                                        '<a href="{{itemUrl}}">' +
                                            '{{itemImg}}' +
                                        '</a>' +
  										'{{itemQuickView}}' +
                                    '</div>' +
                                '</div>' +

                                '<div class="{{blockLayoutClass}}">' +
  										'{{itemcomingsoon}}' +
  										'{{itemeverydaybestbuy}}' +
                                    '<div class="ftr">' +
                                        '<a class="title ftc" href="{{itemUrl}}">{{itemTitle}}</a>' +
                                        '<div class="price ftc {{saleClass}}">{{itemPrice}}</div>' +
  										'{{installementText}}' +
                                    '</div>' +
                                '</div>' +
                                '<span class="product-reviews-badge" data-id="{{ pID }}"></span>' +
  								'<div class="below-image">{{move_to_cart_btn}}' +
  								'<button style="display:none;" class="btn out_of_stock">{{ noAddToCart }}</button></div>' +
                            '</div>'+
  							'</div>',

};

var bvwishlist = getwishlistCookie('bvwishlist');
if (bvwishlist == undefined || bvwishlist == ''){
  
  setwishlistCookie('bvwishlist', JSON.stringify({"items": []}), {expires: 365});
}

var bvwishlist = getwishlistCookie('bvwishlist');
var bvwishlist_json = JSON.parse(bvwishlist);
var bv_customer_id = jQuery('#ms_customer_id').val();
function bvwishlist_count() {
  var bvwishlist = getwishlistCookie('bvwishlist');
  var bvwishlist_json = JSON.parse(bvwishlist);
  if (bvwishlist_json.items.length > 0) {
    jQuery('.bvwishcount').html(bvwishlist_json.items.length);
  } else {
    jQuery('.bvwishcount').html('');
  }
  if (bvwishlist_json.items.length > 0) {
    jQuery('.bvwishcountheader').html('<span>'+bvwishlist_json.items.length+'</span');
  } else {
    jQuery('.bvwishcountheader').html('');
  }
}
var productExists = function (items, product_variant) {
    for (var i = 0; i < items.length; i++) {
      if ((items[i][0] == product_variant[0])){
        return i;
      }
    }
    return -1;
}
$(document).ready(function(){
jQuery('body').on('click', '.move_to_wishlist', function (e) {
  var $this = $(this);
  var lineItemID = $this.attr('data-line_id');

  theme.Helpers.fadeIn(document.querySelector('.ajax-cart__drawer-wrapper .js-mini-cart-loader'));
  jQuery.ajax({
      url: '/cart/change.js',
      data: {line:lineItemID, quantity:0},
      type: "POST",
      dataType: "json",
      success: function (evc) {

        var product_id = $this.attr('data-pid'); //product id
        var variant_id = $this.attr('data-vid'); //variant id
        var product_handle = $this.attr('data-producthandle'); //product handle
        wishlistitem_datalayer(product_handle);
        if(window.customerId){
          saveWishlistItemToDb(variant_id,product_id,product_handle,window.customerId,window.customerEmail);
        }  
        saveDataToCookie(variant_id,product_id,product_handle);

        if (document.querySelector('body').classList.contains('template-cart')) {
          location.reload();
        }else{
          let config = document.getElementById('cart-config');
          if ( !config ) return false;
          config = JSON.parse(config.innerHTML || '{}');
          Shopify.theme.cart.getCart().then(Cart => {
          Shopify.theme.ajaxCart.updateView(config, Cart);
          // Remove page loader
          setTimeout(function(){
            theme.Helpers.fadeOut(document.querySelector('.js-mini-cart-loader'));
          }, 800);
          });
        }
      },
      error: function(xhr, status, error) {
        var err = eval("(" + xhr.responseText + ")");
        console.log(err.message);
      }
  });
  
});


jQuery('body').on('click', '.move_to_cart', function (e) {
  var $this = $(this);
  var pid = $this.attr('data-id');

  theme.Helpers.fadeIn(document.querySelector('.ajax-cart__drawer-wrapper .js-mini-cart-loader'));
  jQuery.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: {id: pid, quantity: 1, form_type: "product"},
    dataType: 'json',
    success: function() {

      var product_id = $this.attr('data-product'); //product id
      var product_handle = $this.attr('data-producthandle');
      wishlistitem_addtocart_datalayer(product_handle);
      if(window.customerId){
        removeWishlistItemToDb(product_id, window.customerId);
      }
      removeDataFromCookie(product_id, product_handle, pid);

      if (document.querySelector('body').classList.contains('template-cart')) {
        location.reload();
      }else{
        let config = document.getElementById('cart-config');
        if ( !config ) return false;
        config = JSON.parse(config.innerHTML || '{}');
        Shopify.theme.cart.getCart().then(Cart => {
          Shopify.theme.ajaxCart.updateView(config, Cart);
          // Remove page loader
          setTimeout(function(){
            theme.Helpers.fadeOut(document.querySelector('.js-mini-cart-loader'));
          }, 800);
        });
      }
    }
  });

  // jQuery.post('/cart/add.js', {
  //   id: pid,
  //   quantity: 1
  // }).done(function(data) {
  //   var product_id = $this.attr('data-product'); //product id
  // 	var product_handle = $this.attr('data-producthandle');
  //   wishlistitem_addtocart_datalayer(product_handle);
  //   if(window.customerId){
	//     removeWishlistItemToDb(product_id,window.customerId);
  //   }
  //   removeDataFromCookie(product_id,product_handle,pid);   
  //   updateCartSummariesnew(true);
  // })
  // .fail(function(data) {
  // 	  console.log(data['responseText']);
  // });
});
});
var shopifyAjaxStorePageURLnew = '/search';
var updateCartSummariesnew = function(showCartSummary) {
  var xMsgText = $('#mini-cart-shipping-savings-message').text();
  var xMsgHTML = $('#mini-cart-shipping-savings-message').html();
  $.get(shopifyAjaxStorePageURLnew, function(data){
    var selectors = ['.custom-info .current-cart', '#cart-summary'];
    var $parsed = $($.parseHTML('<div>' + data + '</div>'));

    for(var i=0; i<selectors.length; i++) {
      var cartSummarySelector = selectors[i];
      var $newCartObj = $parsed.find(cartSummarySelector).clone();
      var $currCart = $(cartSummarySelector);
      $currCart.replaceWith($newCartObj);

    }
    if(showCartSummary) {
      $('body').addClass('show-cart-summary');
    }

  });
}
var noiteminwishlist = function() {
  var bvwishlist = getwishlistCookie('bvwishlist');
  var bvwishlist_json = JSON.parse(bvwishlist);
  if(bvwishlist_json.items.length == 0){
    jQuery(".wishlistitemsgrid").html('<div class="nowishlist">There is no Wishlist item!</div>');
    jQuery('.bvwishcountheader').html('');
  }
}
$(document).ready(function(){
  jQuery('body').on('click', '.wishlistitem a, a.wishlistclose', function (e) {
    e.preventDefault();
   
    var $this = jQuery(this);
    
    var product_id = $this.data('product'); //product id
    var variant_id = $this.data('variant'); //variant id
    var product_handle = $this.data('producthandle'); //product handle
    
    if (product_id != 0) {

      if ($this.attr("data-status") == ""){//add
        
        wishlistitem_datalayer(product_handle);
      }else{ // remove
        wishlistitem_datalayer_remove(product_handle);
      }
      
      var product_variant = [product_id, 1, product_handle,variant_id];
      if ($this.attr("data-status") == "active") //remove
      {
        if(window.customerId){
          removeWishlistItemToDb(product_id,window.customerId);
        }
        
        if($this.hasClass('wishlistclose')){
          $this.parents('.product-block').slideUp(1000, 'swing', function(){
            $this.parents('.product-block').remove();
          });
          
          //$this.parents('.product-block').remove();
        }
        $this.attr('data-status', '');
        
  	  var bvwishlist = getwishlistCookie('bvwishlist');
  	  var bvwishlist_json = JSON.parse(bvwishlist);
        
        bvwishlist_json.items.splice(productExists(bvwishlist_json.items, product_variant), 1);
        setwishlistCookie('bvwishlist', JSON.stringify(bvwishlist_json), {expires: 365});
        bvwishlist_count();
        noiteminwishlist();
        //wishlist_save();
      } else {  //add
        if(window.customerId){
          saveWishlistItemToDb(variant_id,product_id,product_handle,window.customerId,window.customerEmail);
        }
  
        $this.attr('data-status', 'active');
        
        var bvwishlist = getwishlistCookie('bvwishlist');
  	  var bvwishlist_json = JSON.parse(bvwishlist);
        
        bvwishlist_json.items.push(product_variant);
        setwishlistCookie('bvwishlist', JSON.stringify(bvwishlist_json), {expires: 365});
        bvwishlist_count();
        //wishlist_save();
      }
    }
  
  });
});
$(document).ready(function () {
  if(jQuery(".wishlistitemsgrid").length > 0){
  noiteminwishlist();
  jQuery.each(bvwishlist_json.items, function(index, value) {
   
    producthandle = value[2];
    product = value[0];
    if($('.product-'+value[0]).length < 1){
    	getwishproducts(producthandle,index);
    }
  });
  }
})
function getwishproducts(producthandle, index){
  if (producthandle.indexOf('build-your-own-review') > -1) {
    
    var oleurl = AGScriptTag.api_url;
    
    var $producturl = producthandle;
    var paramurl = new URL(producthandle);
    var params = new URLSearchParams(paramurl.search);
    var s = params.get('shank_sku');
    var h = params.get('head_sku');
    var b = params.get('band_sku');
    
    var ole_url_params = []
    ole_url_params.push("s="+s);
    ole_url_params.push("h="+h);
    ole_url_params.push("b="+b);
    var param = "?" + ole_url_params.join("&");
    
	var getoleproduct = oleurl+'/api/getoleproductbyskus'+param;
    var request = new XMLHttpRequest();
    request.open('GET', getoleproduct, true);
    request.onload = function() {
      if (request.status >= 200 && request.status < 400) {
        
        var olepdata = JSON.parse(request.response);
        
        var itemHtml = wishlistFilterTemplate.productGridItemHtml;
        var wishlistitem = bvwishlist_json.items[index];
        var installementText = '';
        var saleClass = '';
        var buttontitle = 'Move To Cart';
        var productid = wishlistitem[0];
        var producttitle = olepdata.title;
        var $wishlistclose = '<a data-status="active" data-product="{{productId}}" class="wishlistclose" href="javascript:void();">X</a>';
        var itemImgHtml = '';
        var img_src = 'https://shopify.bevilles.com.au/api/oleimage?s='+s+'&h='+h+'&b='+b;
        var blockLayoutClass = 'above';
		
        var itemPriceHtml = '';
        var price = parseFloat(olepdata.price);
        var compare_at_price = parseFloat(olepdata.compare_at_price);
        itemPriceHtml += '<span class="amount">$' + price + '</span>';
        if (price < compare_at_price) {
            itemPriceHtml += ' <del>$' + compare_at_price + '</del>';
        }
        
        itemImgHtml += '<div class="reveal">';
          itemImgHtml +=  '<div class="rimage-outer-wrapper">' +
            '<div class="rimage-wrapper lazyload--placeholder">' +
            '<img style="width:100%;" class="rimage__image product__image" src="' + img_src + '" ' +
            'data-widths="[180, 220, 300, 360, 460, 540, 720, 900, 1080, 1296, 1512, 1728, 2048]" data-aspectratio="" ' +
            'data-sizes="auto" alt="{{itemTitle}}"' +
            '/>' +
            '</div>' +
            '</div>' +
            '<noscript>' +
            '<img src="' + img_src + ' alt="{{itemTitle}}" class="rimage__image"/>' +
            '</noscript>';
        itemImgHtml += '</div>';

        var move_to_carthtml = '<a class="btn olewishlistbtn" data-product="{{productId}}" href="{{productHandle}}" data-id="{{ variantID }}">{{buttontitle}}</a>';
        itemHtml = itemHtml.replace(/{{move_to_cart_btn}}/g, move_to_carthtml);
        itemHtml = itemHtml.replace(/{{productIdClass}}/g, productid);
        itemHtml = itemHtml.replace(/{{soldOutClass}}/g, "");
        itemHtml = itemHtml.replace(/{{maxColsClass}}/g, "max-cols-4");
        itemHtml = itemHtml.replace(/{{itemGridWidthClass}}/g, "");
        itemHtml = itemHtml.replace(/{{itemImg}}/g, itemImgHtml);
        itemHtml = itemHtml.replace(/{{WishlistClose}}/g, $wishlistclose);
        itemHtml = itemHtml.replace(/{{productId}}/g, productid);
        itemHtml = itemHtml.replace(/{{productHandle}}/g, $producturl);
        itemHtml = itemHtml.replace(/{{itemcomingsoon}}/g, "");
        itemHtml = itemHtml.replace(/{{noAddToCart}}/g, "");
        itemHtml = itemHtml.replace(/{{itemeverydaybestbuy}}/g, "");
        itemHtml = itemHtml.replace(/{{saleClass}}/g, saleClass);
        itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);
        itemHtml = itemHtml.replace(/{{ pID }}/g, productid);
        itemHtml = itemHtml.replace(/{{ variantID }}/g, "productid");
        itemHtml = itemHtml.replace(/{{installementText}}/g, installementText);
        itemHtml = itemHtml.replace(/{{itemQuickView}}/g, "");
        itemHtml = itemHtml.replace(/{{blockLayoutClass}}/g, blockLayoutClass);
        itemHtml = itemHtml.replace(/{{itemTitle}}/g, producttitle);
        itemHtml = itemHtml.replace(/{{itemHandle}}/g, $producturl);
        itemHtml = itemHtml.replace(/{{itemUrl}}/g, $producturl);
        itemHtml = itemHtml.replace(/{{buttontitle}}/g, "View Product");
        
        jQuery('.wishlistitemsgrid').append(itemHtml);
      }
    };
    request.send();
    return;
  }
  if($('.nowishlist').length > 0){
  	$(".nowishlist").remove();
  }
    var $producturl = window.location.origin+'/products/'+producthandle;
	
  	jQuery.getJSON($producturl+'.js', function (result) {
      
    }).done(function (data) {
      //data = result.product;
      var itemHtml = wishlistFilterTemplate.productGridItemHtml;
      var images = data.images;
      var onSale = data.variants[0].compare_at_price > data.variants[0].price;
      
      var soldOut = !(data.available);
      if(!(data.available)){
        itemHtml = itemHtml.replace(/{{ noAddToCart }}/g, "Out of Stock");
      }
      var comming = false;
      for(var i = 0; i <data.tags.length; i++) {
        if(data.tags[i] == 'instore'){
        	soldOut = true;
          	itemHtml = itemHtml.replace(/{{ noAddToCart }}/g, "Instore Only");
          	break;
        }
        if(data.tags[i] == 'coming-soon'){
          comming = true;
        }
      }
      var installementText = '';
      
      var CP = data.variants[0].price/100;
      if (CP > 1 && CP < 1501) {
        var emi = ((CP)/4);
        var with2Decimals = emi.toString().match(/^-?\d+(?:\.\d{0,2})?/)[0]
        installementText += '<span data-skafos-similar-installment class="installement-limespot">Or 4 payments of $'+ with2Decimals +' with <img src="https://cdn.shopify.com/s/files/1/0057/6657/8279/files/afterpay-logo-png-black-transparent.png?v=1616483054" alt="Afterpay"></span>';
      }
      if ((CP > 1500 && CP < 3000) || CP > 8000){
        var emi = ((CP)/52);
        var with2Decimals = emi.toString().match(/^-?\d+(?:\.\d{0,2})?/)[0]
        installementText += '<span data-skafos-similar-installment class="installement-limespot">or pay $'+ with2Decimals +' per week.*</span>';
      }
      if (CP > 3001 && CP < 8000){
        var $payrightinstallment = getRepayments(CP);
        if($payrightinstallment.totalAmount){
          var numberOfRepayments = $payrightinstallment.numberOfRepayments;
          var emi = ($payrightinstallment.totalAmount)?$payrightinstallment.totalAmount:0;
          var with2Decimals = emi.toString().match(/^-?\d+(?:\.\d{0,2})?/)[0]
          installementText += '<span data-skafos-similar-installment class="installement-limespot">or '+ numberOfRepayments +' fortnightly payments of $'+ with2Decimals +' with <img src="https://cdn.payright.com.au/logo-payright-color.png" height="34" style="max-height: 20px;"></span>';
        }
      }
      
      var $wishlistclose = '<a data-status="active" data-product="{{productId}}" class="wishlistclose" href="javascript:void();">X</a>';
      var move_to_carthtml = '<button class="btn move_to_cart" data-product="{{productId}}" data-producthandle="{{productHandle}}" data-id="{{ variantID }}">{{buttontitle}}</button>';
      
      itemHtml = itemHtml.replace(/{{move_to_cart_btn}}/g, move_to_carthtml);
      itemHtml = itemHtml.replace(/{{WishlistClose}}/g, $wishlistclose);
      itemHtml = itemHtml.replace(/{{productId}}/g, data.id);
      itemHtml = itemHtml.replace(/{{productHandle}}/g, data.handle);
      itemHtml = itemHtml.replace(/{{buttontitle}}/g, "Move To Cart");
        // Coming soon
      itemHtml = itemHtml.replace(/{{itemcomingsoon}}/g, buildcomingsoon(data));
      // every day best buy
      itemHtml = itemHtml.replace(/{{itemeverydaybestbuy}}/g, buildeverydaybestbuy(data));

      // Add maxColsClass
      itemHtml = itemHtml.replace(/{{maxColsClass}}/g, 'max-cols-4');
		var soldOutClass = soldOut ? wishlistFilterTemplate.soldOutClass : '';
      
    itemHtml = itemHtml.replace(/{{soldOutClass}}/g, soldOutClass);
      var itemGridWidthClass = ''
      if (index % 2 == 1) { itemGridWidthClass += 'nth-2 '; }
      if (index % 3 == 1) { itemGridWidthClass += 'nth-3 '; }
      if (index % 4 == 1) { itemGridWidthClass += 'nth-4 '; }
      if (index % 6 == 1) { itemGridWidthClass += 'nth-6 '; }
      itemHtml = itemHtml.replace(/{{itemGridWidthClass}}/g, itemGridWidthClass);

      // Add Block layout class
      var blockLayoutClass = 'above';
      itemHtml = itemHtml.replace(/{{blockLayoutClass}}/g, blockLayoutClass);

      // Add price
      var itemPriceHtml = '';
      var saleClass = '';
      itemPriceHtml += '<span class="amount">$' + (data.variants[0].price/100) + '</span>';
      if (onSale) {
          itemPriceHtml += ' <del>$' + (data.variants[0].compare_at_price/100) + '</del>';
      }
      
      if(comming == true){
      	itemPriceHtml = installementText = '';
      }
      
      itemHtml = itemHtml.replace(/{{saleClass}}/g, saleClass);
      itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);
      itemHtml = itemHtml.replace(/{{ pID }}/g, data.id);
      itemHtml = itemHtml.replace(/{{ variantID }}/g, data.variants[0].id);
      itemHtml = itemHtml.replace(/{{installementText}}/g, installementText);
      
      var itemImgHtml = '';
      var aspect_ratio = '';
      if(typeof images[0] !== "undefined") {
          aspect_ratio = images[0]['width'] / images[0]['height'];
      }
      
      var itemQuickViewHtml = '';
      button = 'Quick';
      if (1 != 1) {
          itemQuickViewHtml += '<div class="quick-buy-wrap pos-middle" style="">';
          itemQuickViewHtml += '<a class="quick-buy ';
          itemQuickViewHtml += 'giant';
          itemQuickViewHtml += '-round-button" href="{{itemUrl}}">' + button + '</a>';
          itemQuickViewHtml += '</div>';
      }
      itemHtml = itemHtml.replace(/{{itemQuickView}}/g, itemQuickViewHtml);
      
      var cover = false;
      var img_src = "https://cdn.shopify.com/shopifycloud/shopify/assets/no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c.gif";
      if(typeof images[0] !== "undefined") {
        img_src = images[0];
      }
      itemImgHtml += '<div class="reveal">';
      itemImgHtml +=  '<div class="rimage-outer-wrapper">' +
                          '<div class="rimage-wrapper lazyload--placeholder">' +
        '<img style="width:100%;" class="rimage__image lazyload fade-in" src="' + img_src + '" ' +
                                  'data-widths="[180, 220, 300, 360, 460, 540, 720, 900, 1080, 1296, 1512, 1728, 2048]" data-aspectratio="' + aspect_ratio + '" ' +
                                  'data-sizes="auto" alt="{{itemTitle}}"' +
                              '/>' +
                          '</div>' +
                      '</div>' +
                      '<noscript>' +
                          '<img src="' + img_src + ' alt="{{itemTitle}}" class="rimage__image"/>' +
                      '</noscript>';
      if (images.length > 1) {
          itemImgHtml += '<img class="hidden" src="' + images[1] + '" alt="{{itemTitle}}" />' ;
      }
      itemImgHtml += '</div>';
      itemHtml = itemHtml.replace(/{{itemImg}}/g, itemImgHtml);
      itemHtml = itemHtml.replace(/{{productIdClass}}/g, data.id);
      itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
      itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
      itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
      itemHtml = itemHtml.replace(/{{itemUrl}}/g, $producturl);

      jQuery('.wishlistitemsgrid').append(itemHtml);
    });
}

function buildeverydaybestbuy(data){
  var htmlbadge = "";
  htmlbadge += '<div class="best-buy">';
  if(data.tags) {
    if($.inArray('best-buy',data.tags) >= 0){
      htmlbadge += '<div class="every-day-best-buy"><p>Every Day Best Buys</p></div>';
    }
  }
  htmlbadge += '</div>';
  return htmlbadge;
}

function buildcomingsoon(data){
  var htmlbadge = "";
  htmlbadge += '<div class="coming-soon-badge">';
  if(data.tags) {
    if($.inArray('coming-soon',data.tags) >= 0){
      htmlbadge += '<div class="sale" style="background: '+theme.settings.comingsoon_badge_bg_color+'; color: '+theme.settings.comingsoon_badge_text_color+';">'+theme.settings.comingsoon_badge+'</div>';
    }
  }
  htmlbadge += '</div>';
  return htmlbadge;
}

var $checkitemload = setInterval(function () {
  if(jQuery(".wishlistitem").length > 0){
	updateWishlist();
    clearInterval($checkitemload);
  }
}, 100);
setInterval(updateWishlist, 3000);
function updateWishlist() {
  jQuery(".wishlistitem").each(function (i) {
    var bvwishlist = getwishlistCookie('bvwishlist');
	var bvwishlist_json = JSON.parse(bvwishlist);
    var $this = jQuery(this);
    var product_id = $this.find('a').attr('data-product'); //product id
    var product_variant = [product_id, 0];
    if (productExists(bvwishlist_json.items, product_variant) > -1) { //add
      $this.find('a').attr('data-status', 'active');
      
    } else {
      $this.find('a').attr('data-status', '');
    }
  });
}
function setwishlistCookie(cname, cvalue, exdays) {
  var d = new Date();
  d.setTime(d.getTime() + (exdays*24*60*60*1000));
  var expires = "expires="+ d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + "; SameSite=none; Secure; path=/";
}

function getwishlistCookie(cname) {
  var name = decodeURIComponent( unescape( unescape(cname + "=")));
  
  var decodedCookie = decodeURIComponent( unescape( unescape(document.cookie)) );
  var ca = decodedCookie.split(';');
  for(var i = 0; i <ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

$(document).ready(function() {
  if(window.customerId){
    var pathname = window.location.pathname;   
    if(pathname == "/pages/wishlist"){
      getwishlistFromDB();
    }
    if(window.userLoggedIn && window.userLoggedIn == "1"){
     	var bvwishlist = getwishlistCookie('bvwishlist');
		var bvwishlist_json = JSON.parse(bvwishlist);
      $.get( AGScriptTag.api_url+"/save_wishlist_all",
      { 
        wishlist_data: bvwishlist_json, 
        customer_id: window.customerId,
        email: window.customerEmail,
      })
      .done(function( data ) {
       // window.userLoggedIn == "done";
      });
    }
  }
});


function getwishlistFromDB() { 
  
  setwishlistCookie('bvwishlist', JSON.stringify({"items": []}), {expires: 365});
  $.get( AGScriptTag.api_url+"/wishlist/"+window.customerId)
      .done(function( data ) {
      	var bvwishlist = getwishlistCookie('bvwishlist');
		var bvwishlist_json = JSON.parse(bvwishlist);
        for (i = 0; i < data.length; i++) {  
          var product_variant = [data[i].product_id, 1, data[i].product_handle];
          bvwishlist_json.items.push(product_variant);
        }
    	setwishlistCookie('bvwishlist', JSON.stringify(bvwishlist_json), {expires: 365});
    	bvwishlist_count();
    
    	var bvwishlist = getwishlistCookie('bvwishlist');
		var bvwishlist_json = JSON.parse(bvwishlist);
    
    	jQuery.each(bvwishlist_json.items, function(index, value) {
          if($('.product-'+value[0]).length < 1){
            producthandle = value[2];
            getwishproducts(producthandle,index);
          }
        });
  });
}

function saveWishlistItemToDb(variant_id, product_id,product_handle,customer_id,customerEmail){
  $.get( AGScriptTag.api_url+"/save_wishlist",
      { 
        product_id: product_id,
    	variant_id: variant_id,
        product_handle: product_handle,
        customer_id: customer_id,
        email: customerEmail,
      })
      .done(function( data ) {
        	return true;
      });
}

function removeWishlistItemToDb(product_id,customer_id){
  $.get( AGScriptTag.api_url+"/remove_from_wishlist/"+product_id+"/"+customer_id)
      .done(function( data ) {
    //console.log("removed from db");
        return true;
      });
}

function saveDataToCookie(variant_id,product_id,product_handle){

	var bvwishlist = getwishlistCookie('bvwishlist');
  	var bvwishlist_json = JSON.parse(bvwishlist);
  
    var product_variant = [product_id, 1, product_handle,variant_id];            
    bvwishlist_json.items.push(product_variant);
    setwishlistCookie('bvwishlist', JSON.stringify(bvwishlist_json), {expires: 365});
    bvwishlist_count();
}

function removeDataFromCookie(product_id,product_handle,variant_id){
    var product_variant = [product_id, 1, product_handle,variant_id];  
  	var bvwishlist = getwishlistCookie('bvwishlist');
    var bvwishlist_json = JSON.parse(bvwishlist);
    bvwishlist_json.items.splice(productExists(bvwishlist_json.items, product_variant), 1);
    setwishlistCookie('bvwishlist', JSON.stringify(bvwishlist_json), {expires: 365});
    bvwishlist_count();
  	$('.product-'+product_id).slideUp(1000, 'swing', function(){
          $('.product-'+product_id).remove();
    });
  	noiteminwishlist();
}
$(document).ready(function(){
  bvwishlist_count();
  // getwishproducts();
});